module.exports = __webpack_public_path__ + "img/lockio-blue.230f8914.svg";